<template>
<div>
    <bar-manut 
        single-entity="Série NF" 
        plural-entity="Série NF" 
        :crud="this.crud" 
        :btn-delete="true"
        @closeform="closeForm" 
        @delete="handleDelete" 
        @save="handleSave">
    </bar-manut>
    <div class="default-container">
        <div>
            <div class="row">
                <form-field v-model="serienf.codfil" type="select2" col="6" :metadata="metadata.serienf.codfil"
                    name="codfil" :v-errors="errors" v-validate="metadata.serienf.codfil.validator"></form-field>
            </div>
            <div class="row">
                <form-field v-model="serienf.serie" type="text" col="4" :metadata="metadata.serienf.serie" 
                    name="serie" :v-errors="errors" v-validate="metadata.serienf.serie.validator"></form-field>
            </div>
            <div class="row">
                <form-field v-model="serienf.esp" type="select2" col="4" :metadata="metadata.serienf.esp"
                    name="esp" :v-errors="errors" v-validate="metadata.serienf.esp.validator"></form-field>
            </div>
            <div class="row">
                <form-field v-model="serienf.nf" :metadata="metadata.serienf.nf" type="text" col="4"
                    name="nf" :v-errors="errors" v-validate="metadata.serienf.nf.validator"></form-field>
            </div>
        </div>
    </div>
</div>

</template>

<script>

import { SysVars } from '../main'
import axios from 'axios'
import { apiORDSpost, apiORDSdelete } from '../shared/api-functions'

export default {
    props: {
        index: '',
        crud: '',
    },

    data() {
        return {
            crudText: '',
            serienf: {...this.$store.getters.getEntities.serienf},
            metadata: this.$store.getters.getEntities.metadata,
            errmessages: [],  //armazena as mensagens de validacao do servidor para mostrar em tela
        }
    },

    computed: {
        editing: function () {
            return this.crud == SysVars.crudU
        }

    },

    methods: {
        closeForm () {
            this.$emit('closeform', this.serienf.esp)
        },

        handleSave () {
            //BOTAO SALVAR
            this.$validator.validateAll().then(isValid => {
                if (!isValid) {
                    this.$erpToastError('Por favor, corrija os campos em destaque para continuar')
                } else {
                    this.apiPost()
                }
            })
        },

        handleDelete () {
            //BOTAO Excluir
            this.apiDelete()
        },

        async loadData () {
            //carrega o registro para alteracao ou visualizacao
            await this.$store.dispatch('loadSerienf', { id: this.index } )
            if (this.$store.getters.getSerienf) {
                this.serienf = {...this.$store.getters.getSerienf}
            }  
            this.$nextTick(function () {
                jQuery('[data-toggle="tooltip"]').tooltip()
            })
        },

        async apiDelete () {
            //efetua a exclusao
            var modulo = 'cg/serienf/' + this.serienf.codserienf

            const data = await apiORDSdelete(this.$store, modulo)
            this.$erpToastDeleted()
            this.closeForm()
        },

        async apiPost () {
            //efetua a gravacao

            var modulo = 'cg/serienf/'
            var sendData = {}

            sendData = { serienf: this.serienf }

            let metodo = 'post'
            let update = false
            if (this.crud != SysVars.crudI) {
                metodo = 'put'
                update = true
            }

            const data = await apiORDSpost(this.$store, modulo, sendData, metodo)
            if (data.errmessages) {
              this.errmessages = data.errmessages
              this.$erpToastError('Alguns erros precisam ser corrigidos.')
            } else {
                if (update) {
                    this.$erpToastUpdated()
                } else {
                    this.$erpToastInserted()
                }
                this.errmessages = {}
                this.serienf = data.items[0]
                this.closeForm()
            }
        },
        
    },

    components: {

    },

    beforeCreate () {

    },

    created () {
        this.$nextTick(function () {
          jQuery('[data-toggle="tooltip"]').tooltip()
        })

        this.crudText = this.$crudText(this.crud)

        if (this.crud == SysVars.crudI) {
            this.serienf.esp = '55'
        } else {
            this.loadData()  
        }
    }

}

</script>

<style>

</style>



// WEBPACK FOOTER //
// src/forms/serienf-form.vue